/**
 * ErrorLogViewComponent  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback, useMemo, useState } from "react";
import { DOC_ERROR_SEVERITY } from "@adapptio/lib-blueprint";
import { ErrorLogView } from "./ErrorLogView";
import { ErrorLogViewErrorsToolbar } from "./components/ErrorLogViewErrorsToolbar";
import { ErrorLogViewErrorsList } from "./components/ErrorLogViewErrorsList";
import { TViewComponent } from "../../../view/IView";
import { Layout } from "../../../ui/components/Layout/Layout";

export const ErrorLogViewComponent: TViewComponent<ErrorLogView> = ({ view }) => {
	const [ severityFilter, setSeverityFilter ] = useState<Set<DOC_ERROR_SEVERITY>>(new Set());
	const layoutState = useMemo(() => view.getLayout(), []);

	const updateSeverityFilter = useCallback<(severity: DOC_ERROR_SEVERITY) => void>((severity) => {
		setSeverityFilter((prevState) => {
			prevState.delete(severity) || prevState.add(severity);
			return new Set(prevState);
		});
	}, []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "errorsToolbar": {
				return (
					<ErrorLogViewErrorsToolbar
						severityFilter={severityFilter}
						onFilterClick={updateSeverityFilter}
						view={view}
					/>
				);
			}
			case "errorsList": {
				return <ErrorLogViewErrorsList view={view} severityFilter={severityFilter} />;
			}

			default: {
				return <p>Error: Undefined panel {componentName}.</p>;
			}
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
